import { EBuildersProjectsActionType } from '../../actions/buildersProjects';
import { DEFAULT_BUILDERS_PROJECTS_DATA } from '../../constants/buildersProjectsData';
import { EBuildersProjectsDataStatus, IBuildersProjectsSchema } from '../../types/buildersProjects';
import { TReduxActions } from '../../types/redux';

const defaultState: IBuildersProjectsSchema = {
  data: DEFAULT_BUILDERS_PROJECTS_DATA,
  status: EBuildersProjectsDataStatus.Initial,
};

export const buildersProjectsReducer = (
  state: IBuildersProjectsSchema = defaultState,
  action: TReduxActions,
): IBuildersProjectsSchema => {
  switch (action.type) {
    case EBuildersProjectsActionType.StartFetching: {
      return {
        ...state,
        status: EBuildersProjectsDataStatus.Fetching,
      };
    }
    case EBuildersProjectsActionType.SetData:
      return {
        data: action.payload,
        status: EBuildersProjectsDataStatus.Success,
      };
    case EBuildersProjectsActionType.AppendData:
      return {
        data: {
          ...state.data,
          ...action.payload,
          projectsList: [...state.data.projectsList, ...action.payload.projectsList],
        },
        status: EBuildersProjectsDataStatus.Success,
      };
    default:
      return state;
  }
};
